var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66406V3.33073M5 1.66406V3.33073",
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99365 10.8359H10.0011M9.99365 14.1693H10.0011M13.3232 10.8359H13.3307M6.66406 10.8359H6.67154M6.66406 14.1693H6.67154",
    stroke: "#718096",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91406 6.66406H17.0807",
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08594 10.2027C2.08594 6.57162 2.08594 4.75607 3.12937 3.62803C4.1728 2.5 5.85218 2.5 9.21094 2.5H10.7943C14.153 2.5 15.8324 2.5 16.8759 3.62803C17.9193 4.75607 17.9193 6.57162 17.9193 10.2027V10.6307C17.9193 14.2617 17.9193 16.0773 16.8759 17.2053C15.8324 18.3333 14.153 18.3333 10.7943 18.3333H9.21094C5.85218 18.3333 4.1728 18.3333 3.12937 17.2053C2.08594 16.0773 2.08594 14.2617 2.08594 10.6307V10.2027Z",
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.66406H17.5",
    stroke: "#718096",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar03);
export default __webpack_public_path__ + "static/media/calendar-03.7768cd43.svg";
export { ForwardRef as ReactComponent };